import axios from "axios"
import { useAppState } from "../redux"
import { useQuery } from "react-query"
import { QueryKeys } from "../../constants/query-keys"

type MatchPriority = {
  id: number,
  org_job_id: number,
  org_job_code: string,
  org_job_code_key: string,
  survey_job_code: string,
  created: Date,
  created_by: number,
  last_modified: Date,
  last_modified_by: number,
  survey_code: string,
  organization_id: number,
  match_priority: number,
  global_job_pricing_version_id: number
}

export const useMatchPriorities = (id: string) => {
  const appState = useAppState()
  const { csrf_timestamp, csrf_token, masterAccountId } = appState.session

  const getVersionMatchPriorities = async (): Promise<{ matchPriorities: MatchPriority[], totalCount: number }> => {
    const response = await axios.get(`/cms/api/accounts/${masterAccountId}/global-job-pricing/versions/${id}/match-priorities?csrf_token=${csrf_token}&csrf_timestamp=${csrf_timestamp}`)
    return response?.data?.data
  }

  const query = useQuery([QueryKeys.GLO_JAM_MATCH_PRIORITIES, { id }], getVersionMatchPriorities)

  return query
}


